import { useQuery } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'

import { searchApplicantQuery } from '@/lib/queries/business/v2/applicant/search/queries'

import { EmptyDashboard } from './ui/empty-dashboard'

/**
 * Home page for the dashboard.
 *
 * If the user has no applicants, they will be prompted to add a new applicant.
 * Otherwise, they will be redirected to the updates page.
 */
export const DashboardEntryPage = () => {
  const navigate = useNavigate()
  const { data: dataApplicants, isPending } = useQuery(searchApplicantQuery({ pageNumber: 1, pageSize: 50 }))
  const applicantsList = dataApplicants?.applicants

  useEffect(() => {
    if (isPending) {
      return
    }

    if (applicantsList && applicantsList?.length > 0) {
      void navigate({ to: '/updates', replace: true, search: { page: 1 } })
    }
  }, [applicantsList, navigate, isPending])

  return (
    <div className="px-10 py-11">
      {isPending ? null : !!applicantsList && applicantsList?.length > 0 ? null : <EmptyDashboard />}
    </div>
  )
}
